module.exports = __webpack_public_path__ + "assets/img/11_1007.a3796066.jpg";